import Head from "next/head";

interface ReportPageHeadProps {
  titleSegments?: string[];
}

const ReportPageHead = (props: ReportPageHeadProps) => {
  const { titleSegments = [] } = props;

  const baseTitleSegments = ["Reports", "Newsela"];
  const title = [...titleSegments, ...baseTitleSegments].join(" | ");

  return (
    <Head>
      <title>{title}</title>
    </Head>
  );
};

export default ReportPageHead;
